export interface LexemeItem {
  name: string
  value: string
  lexeme?: string
}

/**
 * @param item
 * @param lexemeArray
 * TODO: переделать, object.value.toString() спорный момент
 */
export const findLexeme = (
  item: string,
  // lexemeArray: GQLDatingProfileLexicalOptionType[] | { value: string }[]
  lexemeArray: LexemeItem[]
  // ): GQLDatingProfileLexicalOptionType | string[] => {
) => {
  return lexemeArray.find(
    (object) =>
      object &&
      (String(object.value) || !Boolean(object.value)) &&
      (String(object.value) || !Boolean(object.value)).toString() ===
        String(item)
  )
}
